<template>
  <!-- BEGIN : LOGIN PAGE 5-2 -->
  <div class="user-login-5">
    <div class="row bs-reset">
      <div class="col-md-6 col-md-offset-3 login-container">
        <img class="login-logo login-6" src="/static/pages/img/logo.png"/>
        <div class="login-content">
          <h1>{{ title }}</h1>
          <form action="" class="login-form" method="post" v-show="showLogin" v-on:submit.prevent="onSubmit">
            <div class="alert alert-success" v-show="getConfirmation && logErr">
              <button class="close" data-close="alert"></button>
              <span>Your account has been activated successfully. You can now login.</span>
            </div>
            <div class="alert alert-danger" v-show="getLoginError != ''">
              <button class="close" data-close="alert"></button>
              <span>{{ getLoginError }}</span>
            </div>
            <div class="row">
              <div class="col-md-6">
                <input class="form-control form-control-solid placeholder-no-fix form-group" type="text"
                       autocomplete="off" placeholder="Email Address" name="username" v-model="email" @keydown.enter="onSubmit" required/></div>
              <div class="col-md-6">
                <input class="form-control form-control-solid placeholder-no-fix form-group" type="password"
                       autocomplete="off" placeholder="Password" name="password" v-model="password" @keydown.enter="onSubmit" required/></div>
            </div>
            <div class="row">
              <div class="col-sm-offset-4 col-sm-8 text-right">
                <div class="forgot-password">
                  <a id="forget-password" class="forget-password" v-on:click="showRemind" style="color:#d09f23!important;font-size:15px;">Forgot Password?</a>
                </div>
                <button class="btn blue mt-ladda-btn ladda-button sign-in-btn" type="submit" data-style="expand-left">
                  <span class="ladda-label">Sign In</span>
                </button>
              </div>
            </div>
          </form>
          <!-- BEGIN FORGOT PASSWORD FORM -->
          <form class="forget-form" action="javascript:;" method="post" v-show="remindPassword" @submit.prevent="onForgotSubmit">
            <h3 >Forgot Password ?</h3>
            <p> Enter your e-mail address below to reset your password. </p>
            <div class="form-group">
              <input class="form-control placeholder-no-fix" type="text" autocomplete="off" placeholder="Email"
                     name="email" v-model="forgotEmail" /></div>
            <div class="form-actions">
              <button type="button" id="back-btn" class="btn blue btn-outline" v-on:click="hideRemind" >Back</button>
              <button type="submit" class="btn blue pull-right mt-ladda-btn ladda-button forgot-password-btn" data-style="expand-left">
                <span class="ladda-label">Submit</span>
              </button>
            </div>
          </form>
          <!-- END FORGOT PASSWORD FORM -->
        </div>
        <div class="login-footer">
          <div class="row bs-reset">
            <div class="col-md12 bs-reset">
              <div class="login-copyright text-left">
                <p>© {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END : LOGIN PAGE 5-2 -->
</template>
<script>
  import auth from '@/auth'
  import {mapGetters,mapActions} from 'vuex';

  export default {
    name: 'user-login-5',
    data () {
      return {
        title: 'Login to CaseMGR',
        email: '',
        forgotEmail: '',
        password: '',
        remindPassword: false,
        showLogin: true,
        errorLogin: false,
        logged: false,
        logErr: true,
        button: '',
        errorsArray: []
      }
    },
    computed: {
      ...mapGetters({
        getConfirmation:'getConfirmation',
        getLoginError:'getLoginError'
      }),
      wildcard() {
        return '';
      },
      getCurrentYear:function(){
          const d = new Date();
          let year = d.getFullYear();
          return year
      }
    },
    methods: {
      ...mapActions({
        login: 'LOGIN_ACTION',
        forgotPassword: 'FORGOT_PASSWORD_ACTION'
      }),
      showRemind() {
        this.remindPassword = true;
        this.showLogin = false;
        this.$store.state.user.loginError = '';
        this.email = '';
        this.forgotEmail = '';
        this.password = '';
      },
      hideRemind() {
        this.remindPassword = false;
        this.showLogin = true;
        this.$store.state.user.loginError = '';
        this.email = '';
        this.forgotEmail = '';
        this.password = '';
      },
      clearPassword() {
        this.password = '';
      },
      onSubmit() {
        const context = Ladda.create(document.querySelector('.sign-in-btn'));
        var credentials = {
          email: this.email,
          password: this.password
        };
        this.login({credentials, context, organization: this.wildcard, callback: this.clearPassword })
      },
      onForgotSubmit() {
        const context = Ladda.create(document.querySelector('.forgot-password-btn'));
        this.forgotPassword({email: this.forgotEmail, context, _self: this})
      }
    },
    beforeMount() {
      auth.checkAuth();
    },
  }
</script>

<style scoped>
  .user-login-5 {
    background-color: #ffffff;
  }
  .login-logo {
    width: 100%;
    max-width: 450px;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?645ab635